import React from "react";
import { Col } from "react-bootstrap";
import { Calendar } from "primereact/calendar";

/**
 * Year picker above the evaluations grid.
 *
 * The type dropdown that used to live here was disabled and commented out; evaluation type
 * is now chosen in the page header (EvaluationTypeSelector), which is one control rather
 * than two competing ones.
 */
export default function EvaluationsToolbar({ date, onDateChange, isMobile }) {
    const isMobileView = isMobile === 3;
    const rowClass = isMobileView ? "row mb-1" : "flex justify-content-start row mb-4";
    const calColProps = isMobileView ? { lg: 2, xs: 6 } : { lg: 2 };
    const calColClass = isMobileView
        ? "mb-2 d-flex justify-content-center align-items-center"
        : "flex justify-content-start row mb-4";

    return (
        <div className={rowClass}>
            <Col {...calColProps} className={calColClass}>
                <Calendar value={date} onChange={(e) => onDateChange(e.value)} view="year" dateFormat="yy" />
            </Col>
        </div>
    );
}
